// Configure pdfjs-dist's worker once at app boot. Vite-friendly: ?url
// import resolves to a hashed asset URL that survives the build pipeline.
//
// react-pdf re-exports pdfjs so we set the global GlobalWorkerOptions there;
// any react-pdf <Document> after this import sees the configured worker.

import { pdfjs } from "react-pdf";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc as string;
